const tabs = [
  { id: "organize", label: "Organizo" },
  { id: "participate", label: "Participo" },
];

export default function MeetingModeTabs({ value, onChange }) {
  return (
    <div
      className="zx-glass inline-flex w-full rounded-full p-1"
      role="tablist"
      data-testid="meeting-mode-tabs"
    >
      {tabs.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.id)}
            data-testid={`tab-${t.id}`}
            className={[
              "flex-1 px-4 py-2.5 text-[11px] uppercase tracking-[0.22em] transition-all rounded-full",
              active
                ? "bg-[#8B1E3F] text-[#f5f5f5] shadow-[0_4px_18px_rgba(139,30,63,0.45)]"
                : "text-[rgba(255,255,255,0.6)] hover:text-[#f5f5f5]",
            ].join(" ")}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
